import { useState } from "react";
import { useElements } from "@stripe/react-stripe-js";
import { Flex, Box, Text } from "rebass";
import {
	CardNumberElement,
	CardExpiryElement,
	CardCvcElement,
} from "@stripe/react-stripe-js";
import { InputLabel, ErrorLabel } from "./index";

const stripeStyles = {
	style: {
		base: {
			fontFamily: "Raleway, sans-serif",
			fontSize: "16px",
			color: "#424770",
			"::placeholder": {
				color: "#aab7c4",
			},
		},
		invalid: {
			color: "#9e2146",
		},
	},
};

const stripeWrapperStyles = `
	border-radius: 6px;
	border: 1px solid lightgrey;
	background: white;
    margin-bottom: 15px;
	
	& .StripeElement {
		padding: 10px 0px 0px 10px
	}
`;
export const StripeComponents = (props) => {
	const [cardNumberElementError, setCardNumberElementError] = useState("");
	const [cardExpiryElementError, setCardExpiryElementError] = useState("");
	const [cardCVCElementError, setCardCVCElementError] = useState("");

	return (
		<>
			<Flex width="100%">
				<Box width="68%">
					<InputLabel ml={2}>Card Number</InputLabel>
					<Box
						css={`
							${stripeWrapperStyles}
							margin-right: 10px;
						`}
					>
						<CardNumberElement
							onReady={() => console.log("Stripe Elements Ready")}
							onChange={(e) =>
								setCardNumberElementError(
									(e.error && e.error.message) || ""
								)
							}
							options={stripeStyles}
						/>
					</Box>
					{cardNumberElementError && (
						<ErrorLabel data-testid="error-label">
							{cardNumberElementError}
						</ErrorLabel>
					)}
				</Box>
				<Box width="28%">
					<InputLabel ml={2}>Expiry Date</InputLabel>
					<Box css={stripeWrapperStyles}>
						<CardExpiryElement
							onChange={(e) =>
								setCardExpiryElementError(
									(e.error && e.error.message) || ""
								)
							}
							options={stripeStyles}
						/>
					</Box>
					{cardExpiryElementError && (
						<ErrorLabel data-testid="error-label">
							{cardExpiryElementError}
						</ErrorLabel>
					)}
				</Box>
			</Flex>
			<Box>
				<InputLabel
					ml={2}
					helperText="(3 or 4 digit Security Code can be found on the back or front of your card)"
				>
					Security Code
				</InputLabel>
				<Box css={stripeWrapperStyles} width="30%">
					<CardCvcElement
						onChange={(e) =>
							setCardCVCElementError(
								(e.error && e.error.message) || ""
							)
						}
						options={stripeStyles}
					/>
				</Box>
				{cardCVCElementError && (
					<ErrorLabel data-testid="error-label">
						{cardCVCElementError}
					</ErrorLabel>
				)}
			</Box>
		</>
	);
};
